// extracted by mini-css-extract-plugin
module.exports = {"get-notified-section":"styles_get-notified-section__y_NsC","alignment-wrapper":"styles_alignment-wrapper__R2ImX","get-notified-title":"styles_get-notified-title__ovP67"};